import { useContext, useEffect, useState } from "react";
import DataContext from "../../../store/data-context";

export default function useGetItem(itm, slug) {
  const [item, setItem] = useState(itm);
  const dataCtx = useContext(DataContext);

  useEffect(() => {
    if (item === -1) {
      getItem(slug);
    }
  }, []);

  const getItem = async (slug) => {
    try {
      const response = await fetch(
        `https://hogast.hr/wp/wp-json/custom/v1/product/${slug}?lang=${
          dataCtx.lang.lang || "hr"
        }`,
        {
          mode: "cors",
        }
      );

      if (response.ok) {
        let value = await response.json();

        setItem(value);
      }
    } catch (err) {
      setItem(-2);
      console.log("Loading error: ", err.message);
    }
  };

  return [item, getItem];
}
